/* eslint-disable no-restricted-imports */
import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import {
	detailsProductSX,
	disabledTextDetailsSX,
	OrderItemDetailsActionsMobileSX,
	OrderItemDetailsAttributesFrameSX,
	OrderItemDetailsContentSX,
	OrderItemDetailsFrameSX,
	OrderItemDetailsImageBadgeSX,
	OrderItemDetailsImageFrameSX,
	OrderItemDetailsImageSX,
	OrderItemDetailsActionButtonCardSX,
	priceDetailsSX,
	OrderItemDetailsMoreThanOneFrameSX,
} from '@/components/content/OrderHistory/parts/History/style/historyOrders';
import { Box, Stack, Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { useProductDetailsAddToCart, useProductCustomizable } from '@/data/Content/ProductDetails';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import { Img } from '@/components/blocks/MaterialImage';
import { OneClick } from '@/components/blocks/OneClick';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { ProductType } from '@/data/types/Product';
import React from 'react';
import { ProductCustomization } from '@/components/blocks/ProductCustomization';

interface OrderItemDetailsProps {
	product: ProductType;
	currency: string;
	orderItemPrice: number;
	length: number;
}

export const OrderItemDetails: React.FC<OrderItemDetailsProps> = ({
	product,
	length,
	currency,
	orderItemPrice,
}) => {
	const isMobile = useIsMobile();
	const { addToCart } = useProductDetailsAddToCart(product);

	const size = findProductAttribute(product.attributes, 'Talla');
	const { isCustomizable } = useProductCustomizable(product);

	return (
		<Stack
			direction="row"
			sx={length > 1 ? OrderItemDetailsMoreThanOneFrameSX : OrderItemDetailsFrameSX}
		>
			<Stack direction="row" sx={OrderItemDetailsContentSX(isMobile)}>
				<Linkable href={product.seo?.href} sx={OrderItemDetailsImageFrameSX(isMobile)}>
					<Stack direction="column">
						<RenderProductImg
							fullImageRaw={`${product?.thumbnail}`}
							render={(src) => (
								<Img sx={OrderItemDetailsImageSX(isMobile)} src={src} alt={product.name} />
							)}
						/>
						<Box sx={OrderItemDetailsImageBadgeSX(isMobile)}>{'1'}</Box>
					</Stack>
				</Linkable>
				<Stack direction="column" sx={OrderItemDetailsAttributesFrameSX(isMobile)}>
					<Linkable href={product.seo?.href}>
						<Typography component={'h2'} sx={detailsProductSX}>
							{product.name}
						</Typography>
					</Linkable>
					<Typography component={'h3'} sx={disabledTextDetailsSX}>
						{'Talla'} {size?.value}
					</Typography>
					<Typography sx={priceDetailsSX}>
						<PriceDisplay currency={currency} min={orderItemPrice} />
					</Typography>
					<ProductCustomization show={isCustomizable} />
				</Stack>
			</Stack>
			{!isMobile ? (
				<Stack direction="column" sx={OrderItemDetailsActionsMobileSX} spacing={1}>
					<Linkable
						type="button-base"
						sx={OrderItemDetailsActionButtonCardSX}
						href={product.seo?.href}
					>
						{'Ver producto'}
					</Linkable>
					<OneClick
						wrapper="button-base"
						component="a"
						sx={OrderItemDetailsActionButtonCardSX}
						onClick={addToCart}
					>
						{'Volver a comprar'}
					</OneClick>
				</Stack>
			) : null}
		</Stack>
	);
};
